@if (form) {
  <div class="flex flex-col gap-4">
    <form class="flex flex-col gap-4" [formGroup]="form">
      <div class="flex flex-col">
        <label for="memberId">Member ID:</label>
        <p id="memberId">{{ memberSubscriberNumber | emptyPlaceholder }}</p>
      </div>
      <div class="flex flex-col">
        <label for="memberName">Name:</label>
        <p id="memberId">{{ memberFullName | emptyPlaceholder }}</p>
      </div>
      <div class="flex flex-col">
        <label for="dateOfBirth">Date of Birth:</label>
        <p id="dateOfBirth">
          {{ memberDob | emptyPlaceholder }}
        </p>
      </div>
      <div class="flex flex-col">
        <label class="field-required" for="authorizationNumber"
          >Authorization Number:</label
          >
          @if (allowAuthNumberChange) {
            <input
              formControlName="authorizationNumber"
              id="authorizationNumber"
              pInputText
              [class.ng-invalid]="isValid('authorizationNumber')"
              [maxLength]="MAX_LENGTH_AUTH_NUMBER"
              [minlength]="MIN_LENGTH_AUTH_NUMBER"
              />
          } @else {
            <p>{{ authorizationNumber.value }}</p>
          }
          @if (isValid('authorizationNumber')) {
            <small class="p-error">
              Please enter a valid Authorization Number.
            </small>
          }
          @if (authNotFound && previouslySearched === authorizationNumber.value) {
            <small class="p-error">
              The Authorization Number requested cannot be found. Please verify you have the correct Authorization Number.
            </small>
          }
        </div>
        @if (!missingContextFlag) {
          <div  class="flex flex-col">
            <label class="field-required" for="documentType">Document Type:</label>
            <p-multiSelect
              appendTo="body"
              display="chip"
              formControlName="documentType"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              styleClass="w-100"
              [class.ng-invalid]="isValid('documentType')"
              [options]="documentTypes"
              [overlayOptions]="{ baseZIndex: 20000 }"
              [showClear]="true"
            ></p-multiSelect>
          </div>
          <div class="flex flex-col">
            <label for="description">Description:</label>
            <input
              formControlName="description"
              id="description"
              pInputText
              [class.ng-invalid]="isValid('description')"
              [maxlength]="MAX_LENGTH_DESCRIPTION"
              />
              <span class="block text-right"
                >{{
                form?.get("description").value
                ? form.get("description").value.length
                : 0
                }}
                / 40</span
                >
              </div>
            }
          </form>
          <div class="flex flex-row gap-2 justify-end items-center my-2">
            <button
              aria-label="Cancel"
              class="p-button-secondary w-20"
              label="Cancel"
              pButton
              type="button"
              (click)="cancelClick()"
            ></button>
            @if (missingContextFlag) {
              @if (!isSearchLoading) {
                <button
                  aria-label="Search"
                  class="w-20"
                  label="Search"
                  pButton
                  type="submit"
                  [disabled]="authorizationNumber.invalid"
                  (click)="search()"
                ></button>
              } @else {
                <p-progressSpinner ariaLabel="loading" styleClass="p-progress-spinner-sm"/>
              }
            }
            @if (!missingContextFlag) {
              @if (!isLoading) {
                <button
                  aria-label="Attach"
                  class="w-20"
                  label="Attach"
                  pButton
                  type="submit"
                  [disabled]="form.invalid"
                  (click)="submitClick()"
                ></button>
              } @else {
                <p-progressSpinner ariaLabel="loading" styleClass="p-progress-spinner-sm"/>
              }
            }
          </div>
        </div>
      }
